export const CLASS_NAME = 'cst-icon-chevron-down'
